module.exports = __webpack_public_path__ + "img/float-left.be89ac16.svg";